import React from 'react';
import { useNavigate } from 'react-router-dom';
import Encabezados from './Encabezados';

const Tiquetes = () => {
    const navigate = useNavigate();
    const handleOnSubmit = async (e) => {

        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };
    const Salir = () => {
        navigate("/");
    }
    return (
        <div className='main-block'>
        <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
            <div className='formadoShadow'>

                <div className='tituloPantalla'>
                    <p style={{ display: 'inline-block' }}> Tiquetes Electrónicos</p>
                    <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                </div>

                <Encabezados TipoDoc='TIQ' />
            </div>
        </div>
    </div>
    );
};

export default Tiquetes;